import {useQuery} from '@tanstack/react-query'
import {ReviewModalForm} from './ReviewModalForm'
import {QUERIES, isNotEmpty} from '../../../../_metronic/helpers'
import {getOpenBookingById} from '../../../modules/apps/booking/list/core/_requests'
import {ListLoading} from '../../../../_component/ListLoading'
import {useContext} from 'react'
import {BookingContext} from '../../barber-shop/Page'

const ReviewModalFormWrapper = () => {
  const {id, setReviewShow} = useContext(BookingContext)
  const enabledQuery: boolean = isNotEmpty(id)
  const {
    isInitialLoading: isLoading,
    data: booking,
    error,
  } = useQuery(
    [`${QUERIES.BOOKINGS_LIST}-booking-${id}`],
    () => {
      return getOpenBookingById(id)
    },
    {
      enabled: enabledQuery,
      onError: (err) => {
        setReviewShow(false)
        console.error(err)
      },
    }
  )
  isLoading && <ListLoading />
  if (id && !error && booking) {
    return <ReviewModalForm booking={booking} />
  }

  return null
}

export {ReviewModalFormWrapper}
